export default "__VITE_ASSET__yuHtkeRQ__"